export default __webpack_public_path__ + "static/touch-id-5432fa314f1087123ac3269e3cb41495.svg";